import s from './separator.module.styl'
import React from 'react'

export function MenuSeparator(){
    return <span className={s.separator}></span>
}